import React, { memo } from "react";
import { Flex } from "rebass";
import styled from "styled-components";
import { Body } from "../../../text";
import Lottie from "lottie-react";
import loading from "../../../../animations/loading.json";

const Card = styled.div`
  display: block;
  padding-top: 170%;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  height: auto;
  background: #18252d;
  background-size: cover;
  border-color: ${(props) => props.theme.colors.darkerEnvy};
  border-width: 2px;
  border-style: dashed;
`;

const lottieStyle = {
  height: 28,
};

const StyledFlex = styled(Flex)`
  position: absolute;
  top: 50%;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breaks.small}) {
    top: 40%;
  
`;

const Downloading = memo(() => {
  return (
    <Card>
      <StyledFlex
        alignItems="center"
        justifyContent="center"
        flexDirection={["column-reverse", "column-reverse", "row", "row"]}
      >
        <Body mr={[0, 0, 3, 3]} mt={[3, 3, 0, 0]} color="chalk">
          Processing clip...
        </Body>
        <Lottie animationData={loading} loop={true} style={lottieStyle} />
      </StyledFlex>
    </Card>
  );
});

export { Downloading };
